import React, { Component } from 'react'
import { Card, Button, Select, Input, Table, Tag } from 'antd'
import { connect } from 'react-redux'
import { req_page_listKeyword } from '../../api'

import { usrRole } from '../../utils/dataUtil'
import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'

class KeywordList extends Component {
    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        items: [],
        item: {}, // selected
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        userLevel: 'NORMAL',
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'None',
        searchValue: '',
        filterStatus: '',
        loading: false
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_page_items(1)
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token, role, userCode } = this.props.user

        const userLevel = usrRole(role)
        this.setState({ loading: true, userLevel: userLevel })
        const result = await req_page_listKeyword(userLevel, userCode, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })
        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }


    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '關鍵字詞彙',
                width: 120,
                render: (item) => {
                    const {tagContent, total} = item 
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {tagContent}</span> <Tag color={total > 0 ? "red": "lime"}> 被諮詢次數：{total}</Tag>
                        </div>
                    )
                },
            }
        ]
    }

    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    render() {
        const { loading, items, pagination, searchField, searchValue } = this.state
        const title = (
            <>
                <Select value={searchField} style={{ width: 120 }} onChange={value => this.setState({ searchField: value })}>
                    <Select.Option value='None'>搜索條件</Select.Option>
                    <Select.Option value='tagContent'>關鍵字詞彙</Select.Option>
                </Select>
                <Input placeholder="關鍵字" style={{ width: 150, margin: '0 5px' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search" style={{ marginRight: '4px' }}></i>查詢</Button>
            </>
        )
        return (
            <Card title={title}  >
                <Table
                    bordered
                    scroll={{ y: 600 }}
                    loading={loading}
                    rowKey='gid'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(KeywordList)